// @flow
import {
    ADD_BU_FILTER,
    ADD_D_FILTER,
    CLEAR_BU_FILTERS,
    CLEAR_D_FILTERS,
    REMOVE_BU_FILTER,
    REMOVE_D_FILTER,
    ADD_FE_FILTER,
    REMOVE_FE_FILTER,
    CLEAR_FE_FILTERS,
    ADD_TYPE_FILTER,
    REMOVE_TYPE_FILTER,
    CLEAR_TYPE_FILTERS,
    ADD_DATE_FILTER,
    REMOVE_DATE_FILTER,
    CLEAR_DATE_FILTERS,
} from '../actions/filters';

import type { Action } from './types';

const initialState = {
    BUfilterArray: [],
    DfilterArray: [],
    FEfilterArray: [],
    TypeFilterArray: [],
    DateFilterArray: [],
};

//Reducer that manages the BUfilterArray and DfilterArray
export default function ui( state = initialState, action: Action ) {
    switch ( action.type ) {

        case ADD_BU_FILTER:
            return { ...state, BUfilterArray: [ ...state.BUfilterArray, action.filter ] };
        case REMOVE_BU_FILTER:
            return { ...state, BUfilterArray: state.BUfilterArray.filter( item => item !== action.filter ) };
        case CLEAR_BU_FILTERS:
            return { ...state, BUfilterArray: [] };
        case ADD_D_FILTER:
            return { ...state, DfilterArray: [ ...state.DfilterArray, action.filter ] };
        case REMOVE_D_FILTER:
            return { ...state, DfilterArray: state.DfilterArray.filter( item => item !== action.filter ) };
        case CLEAR_D_FILTERS:
            return { ...state, DfilterArray: [] };
        case ADD_FE_FILTER:
            return { ...state, FEfilterArray: [ ...state.FEfilterArray, action.filter ] };
        case REMOVE_FE_FILTER:
            return { ...state, FEfilterArray: state.FEfilterArray.filter( item => item !== action.filter ) };
        case CLEAR_FE_FILTERS:
            return { ...state, FEfilterArray: [] };
        case ADD_TYPE_FILTER:
            return { ...state, TypeFilterArray: [ ...state.TypeFilterArray, action.filter ] };
        case REMOVE_TYPE_FILTER:
            return { ...state, TypeFilterArray: state.TypeFilterArray.filter( item => item !== action.filter ) };
        case CLEAR_TYPE_FILTERS:
            return { ...state, TypeFilterArray: [] };
        case ADD_DATE_FILTER:
            return { ...state, DateFilterArray: [ action.filter ] };
        case REMOVE_DATE_FILTER:
            return { ...state, DateFilterArray: state.DateFilterArray.filter( item => item !== action.filter ) };
        case CLEAR_DATE_FILTERS:
            return { ...state, DateFilterArray: [] };
        default:
            return state;
    }
}